import type { Feeder } from "@/lib/api";
import type { SearchableOption } from "@/components/searchable-selector";

export function feederPickerOption(feeder: Feeder): SearchableOption {
  return {
    value: String(feeder.feeder_id),
    label: feeder.feeder_name,
    context: [feeder.substation_name, feeder.feeder_voltage, feeder.feeder_band, feeder.external_key].filter(Boolean).join(" · "),
    searchText: [
      feeder.external_key, feeder.feeder_name, feeder.substation_name,
      feeder.power_transformer_id, feeder.feeder_band, feeder.feeder_voltage,
      feeder.preferred_network, feeder.installation_type_available,
    ].filter(Boolean).join(" "),
  };
}
